import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { assignUserUUID as _assignUserUUID, initializeSessionUUID as _initializeSessionUUID, setActionTrigger as _setActionTrigger } from '../../state/actions/purchase';
import store from '../../state/store';
import setPersistRoot from './setPersistRoot';
var logger = {
  _loginData: null,

  get loginData() {
    return this._loginData;
  },

  /** loginData
   * data = {type: 'guest', email: ''}
   */
  set loginData(data) {
    this._loginData = data;
  },

  /**
   * The platform should override the sendEvent method so that shared flows may
   * re-use functionality and send the same data.
   */
  sendEvent: function sendEvent(eventType) {
    console.error("Attempted to execute no-op logger.sendEvent(\"".concat(eventType, "\")"));
  },
  generateUUID: function generateUUID() {
    var date = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (characterToReplace) {
      var randomCharacter = (date + Math.random() * 16) % 16 | 0;
      date = Math.floor(date / 16);
      return (characterToReplace === 'x' ? randomCharacter : randomCharacter & 0x3 | 0x8).toString(16);
    });
  },
  storeQueryString: function storeQueryString(queryString) {
    if (queryString) {
      var search = queryString.substring(1);

      if (search.indexOf('fix=me&AccessCode') !== -1) {
        return;
      }

      if (search.indexOf('persistroot=') !== -1) {
        setPersistRoot();
      }
    }
  },
  gameInfo: function gameInfo() {
    var _store$getState$gameI = store.getState().gameInfo,
        gameId = _store$getState$gameI.gameId,
        gameProvider = _store$getState$gameI.gameProvider;
    var payload = {
      game_id: gameId,
      game_provider: gameProvider
    };
    return payload;
  },
  setActionTrigger: function setActionTrigger(action) {
    store.dispatch(_setActionTrigger(action));
  },
  getActionTrigger: function getActionTrigger() {
    return store.getState().purchase.actionTrigger;
  },
  getLastUUID: function getLastUUID() {
    return store.getState().purchase.transaction_uuid;
  },
  assignUserUUID: function () {
    var _assignUserUUID2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var userUUID, state;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = store.getState();
              userUUID = state.purchase.user_uuid;

              if (!userUUID) {
                userUUID = logger.generateUUID();
                store.dispatch(_assignUserUUID(userUUID));
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function assignUserUUID() {
      return _assignUserUUID2.apply(this, arguments);
    }

    return assignUserUUID;
  }(),
  initializeSessionUUID: function () {
    var _initializeSessionUUID2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var sessionUUID;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sessionUUID = store.getState().purchase.session_uuid;

              if (!sessionUUID) {
                sessionUUID = logger.generateUUID();
                store.dispatch(_initializeSessionUUID(sessionUUID));
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function initializeSessionUUID() {
      return _initializeSessionUUID2.apply(this, arguments);
    }

    return initializeSessionUUID;
  }()
};
export default logger;